// vim: set ts=2 sw=2 et tw=72 ft=javascript:
/*
 * Copyright (C) 2016 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:CHALLENGES
 */

var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_'
})(this, function (m_module, Backbone, $, _) {

  "use strict";

  var M = m_module.M;
  M.Community = M.Community || {};
  M.Community.Collection = M.Community.Collection || {};
  M.Community.Collection.CommentList = Backbone.Collection.extend({

    initialize: function(models, options) {
      this.options = options;
      M.required(this.options.commentsUrlPath);
    },

    url: function() {
      return this.options.commentsUrlPath;
    }
  });

  return {
  };

});